import { useEffect } from 'react';

const createSvgIcon = (status) => {
  const color = status === 'online' ? '#10B981' : '#EF4444'; // Hijau atau Merah
  const svg = `
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="none" stroke="${color}" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round">
      <path d="M12 20h.01"/>
      <path d="M8.5 16.429a5 5 0 0 1 7 0"/>
      <path d="M5 12.859a10 10 0 0 1 14 0"/>
      <path d="M2 9.289a15 15 0 0 1 20 0"/>
    </svg>
  `;
  return `data:image/svg+xml;charset=utf-8,${encodeURIComponent(svg.trim())}`;
};

export const useDynamicFavicon = (deviceStatus) => {
  useEffect(() => {
    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement('link');
      link.rel = 'icon';
      document.getElementsByTagName('head')[0].appendChild(link);
    }
    link.href = createSvgIcon(deviceStatus);
  }, [deviceStatus]);
};